import {useParams} from 'react-router-dom'
import {useQuery} from 'react-query'
import {WebFormForm, initialValuesWebFormForm} from '../../../@types'
import React, {useState} from 'react'
import {Get} from '../../../../setup'
import {FileUploadForm, ImgForm, ResponseForm, SatisfactionForm, UpdateNotes, UpdateStatus} from '../components'
import {Download, GenerateStars} from '../../../features'
import {transformDataFormItem} from '../utils/functions'

const TO_PDF = process.env.REACT_APP_EXPORT_TO_PDF || "data-form-pdf";

const GET_DATA_FORM = process.env.REACT_APP_WEB_FORMS_GET_DATA_FORMS

const OverviewForm = () => {

  let {id}: {id: string} = useParams()
  const endpoint = `${GET_DATA_FORM}${id}`
  const [data, setData] = useState<WebFormForm>(initialValuesWebFormForm)
  const [result, setResult] = useState<any[]>([])
  const [client, setClient] = useState<{id: number | undefined, email: string}>({
    email: "", id: -1
  })

  useQuery(
    [`WEB_FORMS_FORM_DATA`, id],
    () => Get<WebFormForm>({ endpoint }),
    {
      onSuccess: (data) => {
        setData(data);

        setClient(prevState => ({...prevState, id: data.users?.id}))

        const transformedResult = transformDataFormItem(data.data).map((item) => {

          if (item.field.includes("e-mail")) setClient(prevState => ({...prevState, email: item.value}))

          if (typeof item.value !== 'string') {
            console.warn(`item.value is not a string:`, item.value);
            return item;
          }

          if (item.type === 'satisfaction') {
            const [type, warningStars = '0', totalStars = '0'] = item.value.split('/');

            if (type === 'star') {
              item.arrayStar = GenerateStars(+warningStars, +totalStars);
            } else if (type === "default") {
              const filledStarsCount = parseInt(item.value.split(' ')[1], 10) || 0;
              item.arrayStar = GenerateStars(filledStarsCount, 5);
              item.value = warningStars;
            } else if (type === "text") {
              item.value = warningStars;
              item.type = 'satisfaction';
            }
          }

          return item;
        });

        setResult(transformedResult);
      },
      onError: (error) => {
        console.error('Error fetching form data:', error);
      },
    }
  );


  return (
    <>
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-lg-row-fluid me-lg-7 me-xl-10 mb-10 mb-lg-0">
          <div className="card">
            <div className="card-header border-0 ">
              <div className="card-title m-0"><h3 className="fw-bolder m-0 fs-5 fs-sm-3">{data.forms?.title}</h3></div>
              <div className="card-toolbar">
                <button
                  type="button"
                  className="btn btn-sm btn-flex btn-light-danger fw-bolder"
                  onClick={() => Download({
                    api: TO_PDF,
                    id,
                    fileName: data.forms?.title || 'data formulaires',
                    fileExtension: 'pdf',
                  })}
                >
                  <i className="bi bi-file-pdf fs-2 " />
                  Pdf
                </button>
              </div>
            </div>
            <div className="card-body border-top px-3 p-sm-4 p-md-8">
              {
                result.map((r, i) => (

                  (r.type === 'signature')
                    ? <ImgForm field={r.field} value={r.value} key={i} />
                    : (r.type === 'satisfaction')
                      ? <SatisfactionForm field={r.field} stars={r} key={i} />
                      : (r.type === 'import_file')
                        ? <FileUploadForm field={r.field} value={r.value} key={i} />
                        : (
                          <div className="row mb-7" key={i}>
                            <label
                              className="col-lg-4 fw-bold text-muted text-capitalize">{r.field}</label>
                            <div className="col-lg-8 fv-row">
                              <span className="fw-bold fs-6">{r.value}</span>
                            </div>
                          </div>
                        )
                ))
              }

              <ResponseForm administratorEmail={data.users?.email || ""} client={client} msg={data.message} />

            </div>

          </div>
        </div>
        <div className="flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0">
          <div className="card bg-light-warning border border-2 border-gray-300 border-hover">
            <div className="card-body p-3">
              <div className="row mb-7">
                <UpdateStatus status={data.status} id={id} />
              </div>
              <div className="row">
                <UpdateNotes notes={data.notes} id={id} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {OverviewForm}